export const ROUTE_LOGIN = '/login';

export const ROUTE_LANDING = '/';
export const ROUTE_HOME = '/home';
export const ROUTE_ABOUT_US = '/about-us';
export const ROUTE_FAQ = '/faq';
export const ROUTE_CREDIT_CARD = '/credit-card';
export const ROUTE_CREDIT_CARD_FORM = `${ROUTE_CREDIT_CARD}/form`;
export const ROUTE_MOBILE_APP = '/mobile-app';
export const ROUTE_PRIVACY_POLICY = '/privacy-and-policy';
export const ROUTE_TERMS_OF_USE = '/terms-of-use';
export const ROUTE_IMPRESSUM = '/legal-notice';

export const ROUTE_CREDIT_REQUEST = '/credit-request';
export const ROUTE_CREDIT_REQUEST_BASIC_SHORT = 'basic';
export const ROUTE_CREDIT_REQUEST_FORM_SHORT = 'form';
export const ROUTE_CREDIT_REQUEST_EXISTS_SHORT = 'exists';
export const ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT = 'documentation';
export const ROUTE_CREDIT_REQUEST_OVERVIEW_SHORT = 'overview';
export const ROUTE_CREDIT_REQUEST_BASIC = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_BASIC_SHORT}`;
export const ROUTE_CREDIT_REQUEST_FORM = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_FORM_SHORT}`;
export const ROUTE_CREDIT_REQUEST_EXISTS = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_EXISTS_SHORT}`;
export const ROUTE_CREDIT_REQUEST_DOCUMENTATION = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_DOCUMENTATION_SHORT}`;
export const ROUTE_CREDIT_REQUEST_OVERVIEW = `${ROUTE_CREDIT_REQUEST}/${ROUTE_CREDIT_REQUEST_OVERVIEW_SHORT}`;

export const ROUTE_CREDIT_REQUEST_VERIFY = '/public/credit';
export const ROUTE_CREDIT_CARD_REQUEST_VERIFY = '/public/card';

export const ROUTE_ERROR_406 = '/error/406';
export const ROUTE_ERROR_500 = '/error/500';
export const ROUTE_ERROR_503 = '/error/503';